import { createContext } from 'react';

const useHospitalCoverateContext = createContext();
export default useHospitalCoverateContext;
